import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import KeyValuePairComponent from './KeyValuePairComponent';

/**
 * @typedef {import("@prismicio/client").Content.KeyValuePairSlice} KeyValuePairSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<KeyValuePairSlice>} KeyValuePairProps
 * @param { KeyValuePairProps }
 */
const KeyValuePair = ({ slice }) => (
  <section>
    <KeyValuePairComponent slice ={slice}/>
  </section>
);

export default KeyValuePair